// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"281":"88f49e31e66dc88e","852":"7a4bfbf1f2424ede"}[chunkId] + ".js";
};